import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from '../components/base/Modal/Modal';
import CompanyModal from './Company';
import {hideModal} from '../actions/Modal';
import ProductModal from './Product';
import WaybillDataModal from './WaybillData';
import FilePreviewModal from './File';
import RodoClauseModalBody from '../components/RodoClause/RodoClauseModalBody';
import PurchaseAddressPickerModal from './PurchaseAddress';
import {COMPANY_PICKER, PRODUCT_PICKER, UPDATE_WAYBILL_DATA, FILE_PREVIEW, RODO_CLAUSE,PURCHASE_ADDRESS} from '../const/Modals';

class RootModal extends React.Component {
    
    onModalCancel = () => this.props.hideModal();
    render() {
        const MODAL_COMPONENTS = {
            COMPANY_PICKER: CompanyModal,
            PRODUCT_PICKER : ProductModal,
            UPDATE_WAYBILL_DATA: WaybillDataModal,
            FILE_PREVIEW: FilePreviewModal,
            RODO_CLAUSE: RodoClauseModalBody,
            PURCHASE_ADDRESS:PurchaseAddressPickerModal

        };
        const ModalBodyComponent = MODAL_COMPONENTS[this.props.modalType];
        if (!this.props.modalType) {
            return null;
        }
        return (
            <Modal
                show
                onHide={this.props.hideModal}
                modalTitle={this.props.modalProps.title}
                modalFooter={this.props.modalProps.footer}>
                <ModalBodyComponent />
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        modalType: state.modal.modalType,
        modalProps: state.modal.modalProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        hideModal: () => dispatch(hideModal())
    };
};

RootModal.propTypes = {
    modalType: PropTypes.string,
    hideModal: PropTypes.func,
    modalProps: PropTypes.object
};

export default connect(mapStateToProps,mapDispatchToProps)(RootModal);




// WEBPACK FOOTER //
// ./src/containers/RootModal.js